<template>
  <div>
    <div v-if="transaction && transaction['api_result']">
      <br />
      <ul>
        <li>
          <h5>
            {{ "status_pay" | setText("Статус оплаты") }}:

            <span
              v-if="
                transaction['api_result']['status'] == 'created' ||
                transaction['api_result']['status'] == 'installment_created'
              "
              >{{
                "iman_done"
                  | setText(
                    "Заказ успешно выполнен (Оплата прошла - IMAN и клиент подтвердили покупку)"
                  )
              }}
            </span>

            <span
              v-else-if="
                transaction['api_result']['status'] == 'agreement_rejected'
              "
              >{{ "client_reject" | setText("Клиент отказался") }}</span
            >

            <span
              v-else-if="
                transaction['api_result']['status'] == 'agreement_accepted'
              "
              >{{
                "iman_client_accept_iman_wait"
                  | setText("Клиент согласился (ожидание статуса от IMAN)")
              }}</span
            >

            <span
              v-else-if="
                transaction['api_result']['status'] == 'waiting_for_approval'
              "
              >{{
                "waiting_for_approval" | setText("Ждём одобрение от клиента")
              }}</span
            >

            <span
              v-else-if="
                transaction['api_result']['status'] == 'not_enough_limit'
              "
            >
              {{
                "not_enough_limit" | setText("Недостаточный лимит клиента")
              }}</span
            >
            <span
              v-else-if="
                transaction['api_result']['status'] ==
                'waiting_for_down_payment'
              "
              >{{
                "waiting_for_down_payment"
                  | setText("Ожидание предоплаты от клиента")
              }}</span
            >

            <span
              v-else-if="transaction['api_result']['status'] == 'calculated'"
              >{{ "calculated" | setText("Цены просчитаны") }}</span
            >

            <span v-else-if="transaction['api_result']['status'] == 'new'">{{
              "new_order" | setText("Новая заявка")
            }}</span>

            <span v-else>{{
              "unknown_status" | setText("Неизвестный статус")
            }}</span>
          </h5>
          <Br />
        </li>
        <li>
          {{ "order_number" | setText("Номер заказа") }}:
          {{ transaction["exchange_id"] }}
        </li>
        <li v-if="transaction['api_result']['installment_id']">
          {{ "contract_number" | setText("Номер контракта") }}:
          {{ transaction["api_result"]["installment_id"] }}
        </li>
        <li v-if="transaction['api_result']['pos_agent_id']">
          {{ "number" | setText("Номер") }} (1):
          {{ transaction["api_result"]["pos_agent_id"] }}
        </li>
        <li v-if="transaction['api_result']['guid']">
          {{ "number" | setText("Номер") }} (2):
          {{ transaction["api_result"]["guid"] }}
        </li>
        <li>
          {{ "system_status" | setText("Системный статус") }}: ({{
            transaction["api_result"]["status"]
          }})
        </li>
        <li>
          {{ "order_price" | setText("Стоимость заказа") }}:
          {{ transaction["api_result"]["total_price"] }} UZS
        </li>
        <li>
          {{ "total_price" | setText("Итоговая стоимость") }} :
          {{ transaction["api_result"]["installment_price"] }} UZS
        </li>
        <li>
          {{ "before_date" | setText("Срок, который выбрал клиент") }} :
          {{ transaction["api_result"]["term"] }} {{ "mo" | setText("мес.") }}
        </li>
      </ul>
    </div>

    <div
      class="text-center"
      v-if="transaction && transaction['pre_api_result']"
    >
      <h3>
        {{
          "info_iman"
            | setText(
              "QR-код сканирует КЛИЕНТ через собственнное приложение Iman Pay"
            )
        }}}
      </h3>

      <h4>{{ "qr_for_client" | setText("QR-Код для клиента") }}:</h4>
      <img
        v-if="transaction['pre_api_result']['qr_code']"
        :src="transaction['pre_api_result']['qr_code']"
        class="qr-code"
      />

      <hr />
      <h4>{{ "problem_qrcode" | setText("Проблема с QR-CODE?") }}</h4>
      <h6 v-if="transaction['pre_api_result']['deep_link']">
        {{ transaction["pre_api_result"]["deep_link"] }}
      </h6>
    </div>

    <div v-if="transaction" class="install-control">
      <button
        v-if="
          $store.state['user']['is_root'] &&
          transaction &&
          transaction['status'] != -1
        "
        @click="cancel"
        class="btn btn-danger"
      >
        {{ "cancel_order" | setText("Отменить заказ") }}
      </button>
      <button @click="check" class="btn btn-success">
        {{ "next_step" | setText("Проверить статус") }}
      </button>
      <!-- <button @click="$emit('next', -1)" class="btn btn-success">
        {{ "next_step" | setText("Завершить") }}
      </button> -->
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    cancel() {
      this.$loading(true);

      logger(this.$http, {
        name: "Отмена запроса в #IMAN",
        description: "",
        model_type: "order",
        model_id: this.order.id,
      });

      this.createTransaction({
        status: -1,
      });
    },
    check() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}installment/application/${this.transaction["exchange_id"]}`,
        method: "GET",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        transformRequest: (data, headers) => {
          delete headers.common["bid"];
          delete headers.common["localization"];
          delete headers.common["shop"];
          delete headers.common["device"];
          delete headers.common["tab"];
          delete headers.common["version"];
          return data;
        },
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              client_confirmed: response.data["status"] === "created" ? 1 : 0,
              api_result: JSON.stringify(response.data),
              month: response.data["term"],
            });
          }
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$notify({
              title: this.partner.name,
              message: error.response.data.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          } else
            this.$notify({
              title: this.partner.name,
              message: "Невозможно получить данные об ошибке. Платеж не прошел",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
    };
  },
};
</script>
<style lang="scss">
.qr-code {
  width: 300px;
  max-width: 100%;
}
</style>
